import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Box, Flex, Text } from "pcln-design-system";
import { StyledLoadingBox } from "../../StyledLoadingBubble.js";
import styled_components from "styled-components";
const ellipsisProps = {
    width: '10px',
    height: '10px',
    borderRadius: '5px',
    bg: '#868d95'
};
const LoadingWrapper = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "Loading__LoadingWrapper"
})([
    "position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1;"
]);
const Loading = ()=>/*#__PURE__*/ jsx(LoadingWrapper, {
        children: /*#__PURE__*/ jsxs(Flex, {
            alignItems: "center",
            children: [
                /*#__PURE__*/ jsx(Text, {
                    fontSize: 3,
                    children: " Loading "
                }),
                /*#__PURE__*/ jsxs(StyledLoadingBox, {
                    mt: 1,
                    width: "62px",
                    height: "32px",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            ...ellipsisProps,
                            id: "ellipses_1"
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            ...ellipsisProps,
                            id: "ellipses_2"
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            ...ellipsisProps,
                            id: "ellipses_3"
                        })
                    ]
                })
            ]
        })
    });
const Loading_Loading = Loading;
export { Loading_Loading as default };
